import { createFileRoute } from "@tanstack/react-router";
import SellCarGuide from "@/pages/ghiduri/SellCarGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/cum-vinzi-o-masina-in-romania/")({
  head: () => routeHead("/ghiduri/cum-vinzi-o-masina-in-romania/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SellCarGuide />
  );
}
